<template>
	<GrigliaContabile modulo="incassi" />
</template>

<script>
import GrigliaContabile from './GrigliaContabile.vue'

export default {
	name: "Incassi",
	components: { GrigliaContabile },
}
</script>
